import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LineChart } from '@/components/charts/line-chart';
import ScenarioOccupancyChartTooltip from '@/routes/(app)/(scenarios)/components/scenario-occupancy-chart-tooltip';
import { useOccupancyChart } from '@/routes/(app)/(scenarios)/hooks/use-occupancy-chart';
import { OccupancyData } from '@/routes/(app)/(scenarios)/types';

interface ScenarioOccupancyChartProps {
  data: OccupancyData;
}

export const ScenarioOccupancyChart: FC<ScenarioOccupancyChartProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const {
    data: chartData,
    lines,
    regions,
  } = useOccupancyChart(data.runs, {
    showSeriesNames: true,
    showMedian: true,
  });

  return (
    <LineChart
      title={t('simulation.charts.occupancy.title')}
      data={chartData.map((row) => ({
        date: row.date,
        regular: row.regular,
        reefer: row.reefer,
      }))}
      indexKey='date'
      tabs={[
        { key: 'regular', label: t('general.regular') },
        { key: 'reefer', label: t('general.reefer') },
      ]}
      showTabTotals={false}
      lines={lines}
      regions={regions}
      yAxisDomain={['auto', 'auto']}
      tooltipContent={<ScenarioOccupancyChartTooltip />}
    />
  );
};
